export default __webpack_public_path__ + "static/media/competencias-gerais.c34f1077.png";